import axios from '../../../helpers/custom-axios';

export const createMC = async (metadata_entry_id, description, option_id) => {
  let metadata_content = { metadata_entry_id, description, option_id };
  return axios
    .post('manage/metadata_contents', metadata_content)
    .then((res) => res)
    .catch((error) => error.response);
};

export const destroyMC = async (mcID) => {
  return axios
    .delete(`manage/metadata_contents/${mcID}`)
    .then((res) => res)
    .catch((error) => error.response);
};

export const updateMC = async (mcID, description) => {
  let metadata_content = { description };
  return axios
    .put(`manage/metadata_contents/${mcID}`, metadata_content)
    .then((res) => res)
    .catch((error) => error.response);
};

export const contentsToUpdate = (entryContents, contentsByEntry) => {
  const determineMetaAction = (meID, currentValue, contents) => {
    // compare original description with current value
    let original = contents.find((ec) => ec[0].id == meID)[1];
    let didChange = original.description != currentValue;
    if (!original.description && currentValue) {
      return 'create';
    } else if (original.description && !currentValue) {
      return 'destroy';
    } else if (original.description && currentValue && didChange) {
      return 'update';
    }
    return false;
  };

  return Object.entries(entryContents).map(([elementID, value]) => {
    let meID = elementID.split('-')[1].split('-')[0];
    return {
      action: determineMetaAction(meID, value, contentsByEntry),
      metadata_entry_id: meID,
      description: value,
    };
  });
};
